/**
 * Shared modal displayed when liveness verification fails
 */

import { FC } from "react";
import { Modal, Text } from "@mantine/core";
import { LargeBtn, color } from "@funded-here-interface/common";
import { MODAL_CONTENT } from "./constants";

interface FailedLivenessModalProps {
  opened: boolean;
  onClose: () => void;
  onContinue: () => void;
  classes: {
    headerText: string;
    text: string;
  };
}

const FailedLivenessModal: FC<FailedLivenessModalProps> = ({
  opened,
  onClose,
  onContinue,
  classes,
}) => {
  return (
    <Modal
      centered
      size="sm"
      overlayProps={{
        blur: 3,
        opacity: 0.1,
      }}
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
    >
      <div style={{ marginTop: 20, marginBottom: 5 }}>
        <Text className={classes.headerText}>{MODAL_CONTENT.TITLE}</Text>
        {MODAL_CONTENT.PARAGRAPHS.map((paragraph, index) => (
          <Text key={index} className={classes.text}>
            {paragraph}
          </Text>
        ))}
        <LargeBtn
          onClick={onContinue}
          backgroundColor={color.FHGREEN}
          textColor="#FFFFFF"
          width="100%"
        >
          Okay
        </LargeBtn>
      </div>
    </Modal>
  );
};

export default FailedLivenessModal;
